import React, { Component } from 'react';
import { connect } from 'react-redux';

import { translate } from '../../../../../react/features/base/i18n/functions';
import Tooltip from '../../../../../react/features/base/tooltip/components/Tooltip';
import { HintsStats } from '../../../../components/hints';
import { isEnabled, isValidRatio } from '../../functions';

/**
 * The type of the React {@code Component} props of {@link HintsTooltip}.
 */
type Props = {

    /**
     * The function to translate human-readable text.
     */
    t: Function,
    enabled: Boolean,
    invalid: Boolean,
    talkRatio: Number | null
};

class HintsTooltip extends Component<Props> {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            talkRatio,
            enabled,
            invalid,
            t
        } = this.props;

        if (!talkRatio) {
            return null;
        }

        return (
            <Tooltip
                content = { <HintsStats /> }
                position = 'bottom'>
                <div className = 'hints-tooltip'>
                    <span className = { enabled && invalid ? 'warning' : '' }>
                        {t('hints.talkRatio')}: {talkRatio}%
                    </span>
                </div>
            </Tooltip>
        );
    }
}

function _mapStateToProps(state) {
    const { currentUser } = state['wildix/features/hints'];

    return {
        talkRatio: currentUser ? currentUser.ratio : null,
        enabled: isEnabled(state),
        invalid: !isValidRatio(state)
    };
}

export default translate(connect(_mapStateToProps)(HintsTooltip));
